import {
  AppFlyoutAnchorProps,
  getSizedFlyoutAnchorStyles,
} from "@1js/acui-button";

import { getFlyoutAnchorProps } from "../../../components/RibbonControlGroupMLR/getRibbonControlGroupItemsProps";
import { getIconBasedOnSize } from "../../../ribbonIconSet";
import { RibbonPreviewGalleryProps } from "../../RibbonControlProps";

export function convertRibbonPreviewGalleryToFlyoutAnchorProps(
  galleryProps: RibbonPreviewGalleryProps
): AppFlyoutAnchorProps {
  const { flyoutAnchorProps, size } = galleryProps;

  // Only set the specific menu props if they exist,
  // otherwise these could overwrite the same props coming from the store
  // (if they got blindly set, potentially to undefined here)
  let menuProps: Partial<AppFlyoutAnchorProps> = {};
  if (galleryProps.expandedOptions) {
    menuProps.menuDefinition = galleryProps.expandedOptions;
  }
  if (galleryProps.deferredMenuDefinition) {
    menuProps.deferredMenuDefinition = galleryProps.deferredMenuDefinition;
  }

  let props: AppFlyoutAnchorProps = {
    type: "AppFlyoutAnchorProps",
    ...flyoutAnchorProps,
    ...menuProps,
    id: galleryProps.id,
    disabled: galleryProps.disabled,
    icon: getIconBasedOnSize(
      galleryProps.flyoutAnchorIconSet,
      galleryProps.size
    ),
    label:
      (galleryProps.flyoutAnchorProps &&
        galleryProps.flyoutAnchorProps.label) ||
      galleryProps.menuLauncherLabel,
    onExecute: galleryProps.onMenuButtonExecute,
    onAfterMenuDismiss: galleryProps.onAfterMenuDismiss,
    keytipProps: galleryProps.keytipProps,
    shadowRenderMenu: galleryProps.shadowRenderMenu,
    persistMenu: true /* Always persist Ribbon Gallery menus */,
  };

  // It is ok to mutate the props here because we just constructed this object.
  // This is also only being done because the function requires all the props to be passed in.
  if (size) {
    props = {
      ...props,
      styles: getSizedFlyoutAnchorStyles(
        props,
        size,
        flyoutAnchorProps?.styles
      ),
      ...getFlyoutAnchorProps(size),
    };
  }

  return props;
}
